module.exports = __webpack_public_path__ + "img/tutorial5.2d36ed1c.png";